// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mutiple-select[data-v-58da00d0] {\n  height: auto;\n  width: 100%;\n  display: inline-block;\n  border: 1px solid #ededed;\n  border-radius: 4px;\n  padding: 2px 4px;\n  min-height: 120px;\n  display: flex;\n  flex-wrap: wrap;\n  box-sizing: border-box;\n}\n", ""]);
// Exports
module.exports = exports;
